import { type ISortParameters, OPERATOR_SORT } from '@features/filters/types';

export const convertSortingPayloadToTableValue = (data: ISortParameters[]) => {
  const sorting = data.map((sort) => ({
    id: sort.field.replaceAll(/_(?<char>[a-z])/gv, (match, p1) =>
      p1.toUpperCase()
    ),
    desc: sort.order === OPERATOR_SORT.DESC,
  }));

  return sorting;
};
